<div class="icon-menu">
  @for(button of buttons; track button.icon) {
    <button (click)="button.callback()" [matTooltip]="button.tooltip"
      mat-icon-button class="icon-menu__button">
      <mat-icon>{{button.icon}}</mat-icon>
    </button>
  }
</div>
